//import { useQuery } from 'react-query';
//import { axiosRequestHandler } from 'helpers/Requests';
import {
  IAttribute,
  IChargingStation,
  IListConnector,
  IStationConnector,
} from 'interfaces/chargingLocator';
import { axiosRequestHandler } from 'helpers/Requests';
import { useQuery } from 'react-query';

export function useEVChargingData(zipcode: string | boolean) {
  const queryKey = `/platform/api/v1/evChargingStations?zipCode=${zipcode}&radius=10&maxResults=200`;
  return useQuery<IChargingStation[], Error>(
    queryKey,
    async () => {
      const { data } = await axiosRequestHandler(queryKey);
      (data as IChargingStation[]).forEach((station) => {
        station.attributes.connectors = station.attributes.connectors.map(
          (connector) => {
            let currentElement: IListConnector = {
              id: '',
              speed: 0,
              amount: 0,
              iconUrl: '',
              quantifier: '',
            };
            let totalAmount = 0;
            connector.listConnectors = [];
            station.properties.forEach((propertiesChecked) => {
              propertiesChecked.outlets.forEach((outlet) => {
                if (outlet.name === connector.name) {
                  if (connector.listConnectors?.length > 0) {
                    for (let i = 0; i < connector.listConnectors.length; i++) {
                      const loopConnector = connector.listConnectors[i];
                      if (
                        loopConnector.id === outlet.name &&
                        loopConnector.speed === outlet.kilowatts
                      ) {
                        loopConnector.amount += 1;
                        totalAmount += 1;
                      } else {
                        if (
                          connector.listConnectors.findIndex(
                            (element) =>
                              element.id === connector.name &&
                              element.speed === outlet.kilowatts
                          ) === -1
                        ) {
                          currentElement.id = connector.name;
                          currentElement.speed = outlet.kilowatts;
                          currentElement.iconUrl = connector.iconUrl;
                          currentElement.amount = 0;
                          currentElement.quantifier =
                            outlet.kilowatts > 125
                              ? 'Very Fast'
                              : outlet.kilowatts >= 50
                              ? 'Fast'
                              : 'Slow';
                          connector.listConnectors.push(
                            JSON.parse(JSON.stringify(currentElement))
                          );
                        }
                      }
                    }
                  } else {
                    currentElement.id = connector.name;
                    currentElement.speed = outlet.kilowatts;
                    currentElement.iconUrl = connector.iconUrl;
                    currentElement.amount = 1;
                    totalAmount += 1;
                    currentElement.quantifier =
                      outlet.kilowatts > 125
                        ? 'Very Fast'
                        : outlet.kilowatts >= 50
                        ? 'Fast'
                        : 'Slow';
                    connector.listConnectors.push(
                      JSON.parse(JSON.stringify(currentElement))
                    );
                  }
                }
              });
            });
            connector.amount = totalAmount;
            return connector;
          }
        );
        const attributeCodes: string[] = [];
        Object.keys(station.attributes).forEach((key) => {
          ((station.attributes as any)[key] || []).forEach(
            (element: IAttribute | IStationConnector) =>
              attributeCodes.push(element.code)
          );
        });
        station.attributeCodeList = attributeCodes;
        if (station.properties.length > 0) {
          station.network = station.properties[0].network;
        }
      });

      return data;
    },
    {
      enabled: zipcode !== false && zipcode !== '',
      staleTime: Infinity,
    }
  );
}
